export const data = {
	heading: 'Запуск инвестиционной платформы',
	firstContent:
		'К 2019 году мы поняли, что мы можем сделать интересный платформенный сервис. С одной стороны у нас были заёмщики, которым нужны деньги. С другой — инвесторы, которые хотели бы, чтобы их деньги приносили пользу. Между ними нужно было построить надёжную систему. Мы приступили к доработке сервиса.',
	secondContent:
		'Мы решили создать инвестиционную платформу, которая бы объединила заёмщиков и инвесторов: чтобы одни могли помогать другим напрямую без крупных институциональных посредников.',
	thirdContent: 'Посмотрите ролик о принципе работы инвестиционной платформы:',
	fourthContent:
		'В этом же году мы вошли в рабочую группу Банка России по мониторингу, оценке потребительских рисков и разработке предложений по регулированию сектора краудфандинга. А затем — объявили о запуске инвестиционной платформы и приступили к разработке инвестиционных продуктов',
}
